import React, { useContext, useEffect } from "react";
import Results from "../../components/dashboard/viewResults/Results";
import { LanguageContext } from "../../context/LanguageContext";

const Dashboard = () => {

  return (
    <div>
      <Results />
    </div>
  );
};

export default Dashboard;
